(function () {
  /* ciw-la-subtotal-footer v9 — subtotal visibility on pin */
  var config = window.ciwLaSubtotalFooter || {};
  var FIRST30 = config.first30 === true || config.first30 === 'true';
  var RELENS20 = config.relens20 === true || config.relens20 === 'true';
  var RELENS20_AMOUNT = parseFloat(config.relens20Amount);
  if (isNaN(RELENS20_AMOUNT)) RELENS20_AMOUNT = 20;
  var INSTALLMENT_FORM_ID = config.installmentFormId || '';

  var TAG_ICON =
    '<svg class="ciw-la-subtotal-card__tag-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
    '<circle cx="7" cy="7" r="1.5" fill="currentColor"/></svg>';

  var MQ_MOBILE_RX = window.matchMedia('(max-width: 749px)');
  var CONTACT_DESKTOP_BTN_OVERHANG = 44;
  var USAGE_STEP_SELECTOR =
    window.ciwLaUsageStepSelector ||
    '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review)';
  var layoutInterval = null;
  var footerResizeObserver = null;
  var headerPlacementObserver = null;
  var layoutFrame = null;
  var scrollEndBoundEl = null;
  var scrollEndFrame = null;
  var wasAtScrollEnd = false;
  var SCROLL_END_THRESHOLD = 12;
  var CARD_LIST_SCROLL_RESUME_MS = 200;
  var cardListFooterInsetLocked = false;
  var cardListLayoutPaused = false;
  var cardListScrollResumeTimer = null;
  var cardListScrollBoundEl = null;
  var cardListFooterObservedEl = null;
  var layoutIntervalPausedForCardListScroll = false;

  function clearContactDesktopFooterButtonWidth(footer) {
    if (!footer) return;
    footer.removeAttribute('data-ciw-la-desktop-btn-sync');
    footer.style.removeProperty('width');
    footer.style.removeProperty('max-width');
    footer.style.removeProperty('align-self');
    footer.style.removeProperty('margin-left');
    footer.style.removeProperty('margin-right');

    var buttonWrap = footer.querySelector('.la-subtotal-footer-button');
    var btn = buttonWrap && buttonWrap.querySelector('.la-prescription-form-btn');
    if (buttonWrap) {
      buttonWrap.style.removeProperty('width');
      buttonWrap.style.removeProperty('max-width');
      buttonWrap.style.removeProperty('padding');
      buttonWrap.style.removeProperty('margin');
      buttonWrap.style.removeProperty('box-sizing');
    }
    if (btn) {
      btn.style.removeProperty('width');
      btn.style.removeProperty('min-width');
      btn.style.removeProperty('max-width');
      btn.style.removeProperty('box-sizing');
    }
  }

  function syncContactDesktopFooterButtonWidth() {
    if (MQ_MOBILE_RX.matches) return;
    if (!isContactLensHost()) return;
    if (!document.body.classList.contains('la-modal-open')) return;

    var footer = getFooter();
    if (!footer || !footer.classList.contains('ciw-la-subtotal-footer--ready')) return;
    if (!footer.closest('.la-prescription-modal-image')) {
      clearContactDesktopFooterButtonWidth(footer);
      return;
    }
    if (isContactSubtotalOnlyStep() || !footer.classList.contains('ciw-la-subtotal-footer--show-action')) {
      clearContactDesktopFooterButtonWidth(footer);
      return;
    }

    var card = footer.querySelector('.ciw-la-subtotal-card');
    var buttonWrap = footer.querySelector('.la-subtotal-footer-button');
    var btn = buttonWrap && buttonWrap.querySelector('.la-prescription-form-btn');
    if (!card || !buttonWrap || !btn) return;

    clearContactDesktopFooterButtonWidth(footer);

    footer.style.setProperty('width', 'max-content', 'important');
    footer.style.setProperty('max-width', '100%', 'important');

    var cardWidth = Math.ceil(card.getBoundingClientRect().width);
    if (!cardWidth) {
      cardWidth = Math.ceil(card.scrollWidth);
    }
    if (!cardWidth) return;

    var buttonWidth = Math.ceil(cardWidth + CONTACT_DESKTOP_BTN_OVERHANG);
    var imageCol = footer.closest('.la-prescription-modal-image');
    var maxWidth = imageCol ? imageCol.getBoundingClientRect().width : 0;
    if (maxWidth > 0) {
      buttonWidth = Math.min(buttonWidth, Math.ceil(maxWidth));
    }

    footer.setAttribute('data-ciw-la-desktop-btn-sync', '1');
    footer.style.setProperty('width', 'auto', 'important');
    footer.style.setProperty('max-width', '100%', 'important');
    footer.style.setProperty('align-self', 'center', 'important');
    footer.style.setProperty('margin-left', 'auto', 'important');
    footer.style.setProperty('margin-right', 'auto', 'important');

    buttonWrap.style.setProperty('width', buttonWidth + 'px', 'important');
    buttonWrap.style.setProperty('max-width', '100%', 'important');
    buttonWrap.style.setProperty('padding', '0 0 12px', 'important');
    buttonWrap.style.setProperty('margin', '0', 'important');
    buttonWrap.style.setProperty('box-sizing', 'border-box', 'important');

    btn.style.setProperty('width', '100%', 'important');
    btn.style.setProperty('max-width', 'none', 'important');
    btn.style.setProperty('box-sizing', 'border-box', 'important');
  }

  function scheduleContactDesktopFooterButtonWidth() {
    window.requestAnimationFrame(function () {
      syncContactDesktopFooterButtonWidth();
      window.requestAnimationFrame(syncContactDesktopFooterButtonWidth);
    });
  }

  function isCiwLaHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isActive() : !!document.querySelector('.ciw-pdp');
  }

  function isContactLensHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function isContactSubmissionMethodStep() {
    if (!isContactLensHost()) return false;
    if (!document.body.classList.contains('la-modal-open')) return false;

    var wrapper = document.querySelector('.la-prescription-wrapper:not(form)');
    return !!(wrapper && isVisibleInModal(wrapper));
  }

  function hasContactRxFieldItems(form) {
    if (!form) return false;
    return Array.from(form.querySelectorAll('.la-prescription-fields-wrapper .la-form-item[key]')).some(function (item) {
      var key = item.getAttribute('key');
      return (
        key === 'sph' ||
        key === 'cyl' ||
        key === 'axis' ||
        key === 'base_curve' ||
        key === 'diameter' ||
        key === 'add'
      );
    });
  }

  function isContactManualEntryStep() {
    if (!isContactLensHost()) return false;
    if (!document.body.classList.contains('la-modal-open')) return false;
    if (isContactUploadStep()) return false;

    var form = document.querySelector('#la-prescription-form');
    if (!form) return false;
    if (form.classList.contains('ciw-la-contact-rx-form--mobile')) return true;
    if (form.querySelector('.ciw-la-contact-rx-card')) return true;
    if (form.querySelector('.la-right-rx-container') && form.querySelector('.la-left-rx-container')) {
      return true;
    }
    return hasContactRxFieldItems(form);
  }

  function isContactUploadStep() {
    if (!isContactLensHost()) return false;
    if (!document.body.classList.contains('la-modal-open')) return false;

    var form = document.querySelector('#la-prescription-form');
    return !!(form && form.classList.contains('ciw-la-contact-upload-form--mobile'));
  }

  function isContactSubtotalOnlyStep() {
    if (!isContactLensHost()) return false;
    if (!document.body.classList.contains('la-modal-open')) return false;
    return isContactSubmissionMethodStep();
  }

  function isContactLensFormStep() {
    if (!isContactLensHost()) return false;
    if (isContactSubmissionMethodStep()) return true;
    if (isContactManualEntryStep()) return true;
    if (isContactUploadStep()) return true;
    return !!document.querySelector('.la-quantity-selector-wrapper');
  }

  function formatMoneyFromAmount(amount) {
    var cents = Math.round(parseFloat(amount || 0) * 100);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify.theme && window.Shopify.theme.moneyFormat) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getFooter() {
    return document.querySelector('.la-prescription-modal-footer');
  }

  function getModalHost() {
    return document.getElementById('lensadvizor-prescription-modal');
  }

  function getRxWrapper() {
    return document.querySelector('.la-prescription-modal-wrapper');
  }

  function getUsageStepWrapper() {
    return document.querySelector(USAGE_STEP_SELECTOR);
  }

  function isPrescriptionTypeStep() {
    if (isManualEntryStep()) return false;
    return !!getUsageStepWrapper();
  }

  function hasModalStepContent() {
    var body = document.querySelector('.la-prescription-modal-content-body');
    if (!body) return false;

    if (
      body.querySelector(
        '.la-choose-prescription-wrapper, #la-prescription-form, .la-prescription-form, .la-lens-options-wrapper, .la-lens-wrapper, .la-add-ons-wrapper, .la-review-wrapper, form[name="la-prescription-form"], .la-prescription-wrapper'
      )
    ) {
      return true;
    }

    var visibleChildren = Array.prototype.filter.call(body.children, function (el) {
      if (!el) return false;
      if (el.id === 'la-loader-internal' || el.id === 'la-loader') return false;
      if (el.classList && el.classList.contains('la-lens-loader')) return false;
      if (el.hasAttribute('hidden')) return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

    return visibleChildren.length > 0;
  }

  function isPastUsageStep() {
    if (isContactLensFormStep()) return true;
    if (isManualEntryStep()) return true;
    if (isUploadRxStep()) return true;
    if (isPrescriptionTypeStep()) return false;
    var la = getLensAdvizor();
    if (la && la.stepIndex > 1) return true;
    return hasModalStepContent();
  }

  function shouldApplyFlowLayoutFix() {
    if (!document.body.classList.contains('la-modal-open')) return false;
    if (!isCiwLaHost()) return false;
    if (isCardListSubtotalOnlyStep()) return false;
    if (isPrescriptionTypeStep()) return false;
    if (!getFooter() || !getRxWrapper()) return false;
    return isPastUsageStep();
  }

  function shouldApplyRxLayoutFix() {
    if (isCardListSubtotalOnlyStep()) return false;
    return (
      document.body.classList.contains('la-modal-open') &&
      isPrescriptionTypeStep() &&
      MQ_MOBILE_RX.matches
    );
  }

  function getLensAdvizor() {
    return window.LensAdvizor || null;
  }

  function isReviewStep() {
    if (document.querySelector('.la-choose-prescription-wrapper.la-render-review')) {
      return true;
    }
    var la = getLensAdvizor();
    if (!la || !la.navigationSteps || !la.stepIndex) return false;
    var current = la.navigationSteps[la.stepIndex - 1];
    return typeof current === 'string' && current.indexOf('renderReview') !== -1;
  }

  function isUploadRxStep() {
    var form = document.querySelector('#la-prescription-form');
    if (!form) return false;
    if (isContactLensHost()) {
      return form.classList.contains('ciw-la-contact-upload-form--mobile');
    }
    return form.classList.contains('ciw-la-upload-rx-form--mobile');
  }

  function isManualEntryStep() {
    if (isContactLensFormStep()) return false;
    if (isUploadRxStep()) return false;
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (
      !document.body.classList.contains('ciw-la-manual-rx-step-active') &&
      !(modal && modal.classList.contains('ciw-la-manual-rx-step-active'))
    ) {
      return false;
    }
    var form = document.querySelector('#la-prescription-form');
    if (!form) return false;
    return !!(
      form.querySelector('.la-right-rx-container') &&
      form.querySelector('.la-left-rx-container')
    );
  }

  function isLensPackageContinueStep() {
    return (
      document.body.classList.contains('ciw-la-lens-package-continue-active') &&
      !!document.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)')
    );
  }

  function isLensThicknessContinueStep() {
    return (
      document.body.classList.contains('ciw-la-lens-thickness-continue-active') &&
      !!document.querySelector('.la-choose-prescription-wrapper.ciw-la-lens-thickness-step')
    );
  }

  function isLensColorContinueStep() {
    if (!document.body.classList.contains('ciw-la-lens-color-continue-active')) return false;
    if (isLensPackageContinueStep()) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.ciw-la-lens-color-step')) return true;
    var api = window.ciwLaLensColorContinue;
    return !!(api && typeof api.hasSelection === 'function' && api.hasSelection());
  }

  function isSunglassesLensSelectionStep() {
    return (
      document.body.classList.contains('ciw-la-sunglasses-lens-selection-active') &&
      !!document.querySelector('.la-choose-prescription-wrapper.ciw-la-sunglasses-lens-selection-step')
    );
  }

  function isSunglassesPackageContinueStep() {
    if (
      !(
        document.body.classList.contains('ciw-la-sunglasses-post-confirm') ||
        document.body.classList.contains('ciw-la-sunglasses-package-revealed')
      )
    ) {
      return false;
    }
    if (isReviewStep() || isAddOnsStep()) return false;
    var scope = document.querySelector(
      '.la-choose-prescription-wrapper.la-render-options.ciw-la-lens-package-step'
    );
    if (!scope || scope.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(scope);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return scope.getClientRects().length > 0;
  }

  function isProgressivePackageContinueStep() {
    return (
      document.body.classList.contains('ciw-la-progressive-package-active') &&
      isSunglassesPackageContinueStep()
    );
  }

  function isProgressiveTypeOptionsStep() {
    if (isContactLensHost()) return false;
    return !!document.querySelector(
      '.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step'
    );
  }

  function isProgressiveTypeContinueStep() {
    return false;
  }

  function isTransitionsDrawerStep() {
    return (
      document.body.classList.contains('ciw-la-transitions-drawer-active') &&
      !!document.querySelector('.la-choose-prescription-wrapper.ciw-la-transitions-drawer-step')
    );
  }

  function isRenderOptionsStep() {
    if (isContactLensHost()) return false;
    if (isLensThicknessContinueStep()) return false;
    if (isLensColorContinueStep()) return false;
    if (!document.querySelector('.la-choose-prescription-wrapper.la-render-options')) return false;
    /* GlassesUSA-style: la-render-options card steps auto-advance on click.
       Continue is only for steps that still use a confirm button (not these scopes). */
    if (document.querySelector('.la-choose-prescription-wrapper.ciw-la-lens-package-step')) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.ciw-la-lens-thickness-step')) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.ciw-la-lens-color-step')) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step')) return false;
    return true;
  }

  function isAddOnsStep() {
    if (isContactLensHost()) return false;
    return !!document.querySelector('.la-choose-prescription-wrapper.la-render-addons');
  }

  function isAddOnsContinueStep() {
    return (
      document.body.classList.contains('ciw-la-addons-continue-active') &&
      !!document.querySelector('.la-choose-prescription-wrapper.la-render-addons')
    );
  }

  function isLensTypeStep() {
    if (isContactLensHost()) return false;
    if (document.body.classList.contains('ciw-la-lens-package-continue-active')) return false;
    if (document.body.classList.contains('ciw-la-lens-thickness-continue-active')) return false;
    if (document.body.classList.contains('ciw-la-lens-color-continue-active')) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.la-render-options')) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.la-render-addons')) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.la-render-review')) return false;
    if (document.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)')) {
      return false;
    }
    if (isManualEntryStep()) return false;
    return !!document.querySelector('.la-choose-prescription-wrapper.la-render-lenses.x-pro');
  }

  function isVisibleInModal(el) {
    if (!el || el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function isSubmissionMethodStep() {
    if (isContactLensHost()) return false;
    if (
      isLensColorContinueStep() ||
      isLensThicknessContinueStep() ||
      isLensPackageContinueStep() ||
      isAddOnsContinueStep()
    ) {
      return false;
    }
    var wrapper = document.querySelector('.la-prescription-wrapper:not(form)');
    return !!(wrapper && isVisibleInModal(wrapper));
  }

  function shouldKeepScrollableLayout() {
    return (
      isContactManualEntryStep() ||
      isContactUploadStep() ||
      isLensPackageContinueStep() ||
      isLensThicknessContinueStep() ||
      isLensColorContinueStep() ||
      isSunglassesLensSelectionStep() ||
      isProgressiveTypeOptionsStep() ||
      isProgressivePackageContinueStep() ||
      isSunglassesPackageContinueStep() ||
      isTransitionsDrawerStep() ||
      isAddOnsContinueStep() ||
      isRenderOptionsStep() ||
      isManualEntryStep() ||
      isUploadRxStep() ||
      isLensTypeStep() ||
      isSubmissionMethodStep() ||
      isPrescriptionTypeStep()
    );
  }

  function shouldShowFooterActionButton() {
    if (isContactSubtotalOnlyStep()) return false;
    if (isContactLensFormStep()) return true;
    if (isReviewStep()) return true;
    if (isManualEntryStep()) return true;
    if (isUploadRxStep()) return true;
    /* GlassesUSA-style: card-pick steps auto-advance — no Continue button on any viewport. */
    if (isLensPackageContinueStep()) return false;
    if (isLensThicknessContinueStep()) return false;
    if (isLensColorContinueStep()) return false;
    if (isSunglassesLensSelectionStep()) return true;
    if (isProgressiveTypeOptionsStep()) return false;
    /* Sunglasses package auto-advances on card tap — no Continue (same as thickness/color/package). */
    if (isProgressivePackageContinueStep() || isSunglassesPackageContinueStep()) return false;
    if (isTransitionsDrawerStep()) {
      var transitionsApi = window.ciwLaTransitionsDrawer;
      return !!(
        transitionsApi &&
        typeof transitionsApi.isContinueEnabled === 'function' &&
        transitionsApi.isContinueEnabled()
      );
    }
    if (isAddOnsContinueStep()) {
      var addonsContinueApi = window.ciwLaAddonsContinue;
      if (
        addonsContinueApi &&
        typeof addonsContinueApi.canSkip === 'function' &&
        addonsContinueApi.canSkip()
      ) {
        return true;
      }
      return !!(addonsContinueApi && addonsContinueApi.hasSelection());
    }
    if (isRenderOptionsStep()) return true;
    if (isPrescriptionTypeStep() || isSubmissionMethodStep() || isLensTypeStep()) return false;
    return false;
  }

  function fixModalHeaderPlacement() {
    if (!isCiwLaHost()) return;
    if (!document.body.classList.contains('la-modal-open')) return;
    var wrapper = getRxWrapper();
    var header = document.getElementById('la-prescription-modal-header');
    if (!wrapper || !header) return;

    if (MQ_MOBILE_RX.matches) {
      if (header.parentElement !== wrapper) {
        wrapper.insertBefore(header, wrapper.firstChild);
      }
      return;
    }

    var imageCol = wrapper.querySelector(':scope > .la-prescription-modal-image');
    if (imageCol && header.parentElement !== imageCol) {
      imageCol.insertBefore(header, imageCol.firstChild);
    }
  }

  function watchHeaderPlacement(wrapper) {
    if (!wrapper) return;
    if (headerPlacementObserver) return;
    if (typeof MutationObserver === 'undefined') return;

    headerPlacementObserver = new MutationObserver(function () {
      fixModalHeaderPlacement();
    });
    headerPlacementObserver.observe(wrapper, { childList: true, subtree: true });
  }

  function stopHeaderPlacementWatch() {
    if (!headerPlacementObserver) return;
    headerPlacementObserver.disconnect();
    headerPlacementObserver = null;
  }

  function syncReviewStepClass() {
    var wrapper = getRxWrapper();
    if (!wrapper) return;
    var onReview = isReviewStep();
    wrapper.classList.toggle('ciw-la-review-step', onReview);
    if (MQ_MOBILE_RX.matches && onReview) {
      wrapper.classList.add('ciw-la-flow-step');
    }
  }

  function moveFooterToWrapper(wrapper, footer) {
    if (footer && footer.parentElement !== wrapper) {
      wrapper.appendChild(footer);
    }
  }

  function moveFooterToImageColumn(wrapper) {
    if (!wrapper) wrapper = getRxWrapper();
    var imageCol = wrapper && wrapper.querySelector(':scope > .la-prescription-modal-image');
    var footer = getFooter();
    if (!footer || !imageCol) return;

    if (MQ_MOBILE_RX.matches) {
      if (footer.parentElement === wrapper && !wrapper.classList.contains('ciw-la-flow-step')) {
        imageCol.appendChild(footer);
      }
      return;
    }

    if (footer.parentElement !== imageCol) {
      imageCol.appendChild(footer);
    }
  }

  var DESKTOP_ACTION_BUTTON_CLASS = 'ciw-la-desktop-action-button';

  function getContentBody() {
    return document.querySelector('.la-prescription-modal-content .la-prescription-modal-content-body');
  }

  /* Desktop moves the LA action button into the right pane; clicks must match either location. */
  function isLaModalActionButton(btn) {
    if (!btn || !btn.classList || !btn.classList.contains('la-prescription-form-btn')) return false;
    return !!(
      btn.closest('.la-prescription-modal-footer') ||
      btn.closest('.la-prescription-modal-content-body') ||
      btn.closest('.ciw-la-review-card__inner')
    );
  }

  /* Where the relocated desktop action button should live in the right pane.
     On the Review step GlassesUSA puts the button INSIDE the white summary card,
     so target that card; every other step drops it below the cards/form in the
     content body. */
  function getDesktopButtonTarget() {
    if (isReviewStep()) {
      var cardInner = document.querySelector('.la-render-review .ciw-la-review-card__inner');
      if (cardInner) return cardInner;
      var card = document.querySelector('.la-render-review .ciw-la-review-card');
      if (card) return card;
    }
    return getContentBody();
  }

  function findActionButtonWrap() {
    var footer = getFooter();
    if (footer) {
      var inFooter = footer.querySelector('.la-subtotal-footer-button');
      if (inFooter) return inFooter;
    }
    var inContent = document.querySelector(
      '.la-prescription-modal-content-body > .la-subtotal-footer-button'
    );
    if (inContent) return inContent;
    /* LensAdvizor keeps a live reference to its single persistent button wrap in
       `formBtn`. When we relocate it into the right pane and LA later re-renders the
       content body (e.g. the Review step), that node gets detached but `la.formBtn`
       still points to it — return it here so placement can re-attach the SAME node
       (with LA's own click handler intact) instead of losing the button entirely. */
    var la = getLensAdvizor();
    var laFormBtn = la && la.formBtn;
    if (
      laFormBtn &&
      laFormBtn.classList &&
      laFormBtn.classList.contains('la-subtotal-footer-button')
    ) {
      return laFormBtn;
    }
    return null;
  }

  /* GlassesUSA desktop: subtotal stays in the left image column; the primary action
     button moves into the right content pane below the step cards. Mobile keeps the
     button pinned under the subtotal block in the footer. */
  function syncDesktopActionButtonPlacement(footer) {
    if (!footer) footer = getFooter();
    var buttonWrap = findActionButtonWrap();
    if (!buttonWrap || !footer) return;

    var contentBody = getContentBody();

    if (MQ_MOBILE_RX.matches) {
      if (buttonWrap.parentElement !== footer) {
        footer.appendChild(buttonWrap);
      }
      buttonWrap.classList.remove(DESKTOP_ACTION_BUTTON_CLASS, 'ciw-la-action-in-review-card');
      footer.classList.remove('ciw-la-subtotal-footer--action-in-pane');
      return;
    }

    var moveToRightPane =
      !MQ_MOBILE_RX.matches &&
      isCiwLaHost() &&
      !isContactLensHost() &&
      contentBody &&
      footer.classList.contains('ciw-la-subtotal-footer--show-action') &&
      shouldShowFooterActionButton();

    if (moveToRightPane) {
      var target = getDesktopButtonTarget() || contentBody;
      if (buttonWrap.parentElement !== target) {
        target.appendChild(buttonWrap);
      }
      buttonWrap.classList.add(DESKTOP_ACTION_BUTTON_CLASS);
      buttonWrap.classList.toggle('ciw-la-action-in-review-card', isReviewStep());
      footer.classList.add('ciw-la-subtotal-footer--action-in-pane');
      return;
    }

    if (buttonWrap.parentElement !== footer) {
      footer.appendChild(buttonWrap);
    }
    buttonWrap.classList.remove(DESKTOP_ACTION_BUTTON_CLASS, 'ciw-la-action-in-review-card');
    footer.classList.remove('ciw-la-subtotal-footer--action-in-pane');
  }

  function syncPinnedFooterModalClass() {
    var modal = getModalHost();
    if (!modal) return;
    var pinned = !!modal.querySelector(
      ':scope > .la-prescription-modal-footer.ciw-la-review-footer--pinned'
    );
    modal.classList.toggle(
      'ciw-la-pinned-footer-active',
      pinned && MQ_MOBILE_RX.matches && hasModalStepContent()
    );
  }

  /* GlassesUSA mobile: footer is always a direct child of the modal shell, fixed to
     the viewport bottom. Never leave it in the image column or wrapper grid row. */
  function ensureMobileFooterPinned() {
    if (!MQ_MOBILE_RX.matches) return false;
    if (!document.body.classList.contains('la-modal-open')) return false;
    if (!isCiwLaHost()) return false;
    if (!hasModalStepContent()) return false;

    var modal = getModalHost();
    var footer = getFooter();
    var wrapper = getRxWrapper();
    if (!modal || !footer || !wrapper) return false;

    ensureSubtotalCard(footer);
    if (footer.parentElement !== modal) {
      modal.appendChild(footer);
    }
    footer.classList.add('ciw-la-review-footer--pinned', 'ciw-la-mobile-footer-shell');
    wrapper.classList.add('ciw-la-review-footer-active');
    syncPinnedFooterModalClass();
    return true;
  }

  function unpinReviewFooter(wrapper) {
    if (!wrapper) wrapper = getRxWrapper();
    var footer = getFooter();
    if (footer) {
      footer.classList.remove('ciw-la-review-footer--pinned', 'ciw-la-mobile-footer-shell');
    }
    if (wrapper) {
      wrapper.classList.remove('ciw-la-review-footer-active');
    }
    syncPinnedFooterModalClass();
    if (
      footer &&
      wrapper &&
      shouldApplyFlowLayoutFix() &&
      MQ_MOBILE_RX.matches &&
      footer.parentElement !== wrapper
    ) {
      wrapper.appendChild(footer);
      return;
    }

    if (footer && wrapper && shouldApplyFlowLayoutFix() && !MQ_MOBILE_RX.matches) {
      moveFooterToImageColumn(wrapper);
    }
  }

  function isCardListSubtotalOnlyStep() {
    if (isContactLensHost()) {
      return isContactSubmissionMethodStep();
    }
    if (isManualEntryStep()) return false;
    if (isLensPackageContinueStep()) return false;
    if (isLensThicknessContinueStep()) return false;
    if (isLensColorContinueStep()) return false;
    if (isSunglassesLensSelectionStep()) return false;
    if (isTransitionsDrawerStep()) return false;
    if (isRenderOptionsStep()) return false;
    if (isAddOnsStep()) return false;
    if (isReviewStep()) return false;
    return isPrescriptionTypeStep() || isSubmissionMethodStep() || isLensTypeStep();
  }

  function isCardListMobileStepActive() {
    return MQ_MOBILE_RX.matches && document.body.classList.contains('ciw-la-card-list-step');
  }

  function applyCardListFooterScrollEndState(footer) {
    if (!footer) footer = getFooter();
    if (!footer) return;
    footer.classList.add('ciw-la-footer-at-scroll-end');
    footer.classList.remove(
      'ciw-la-footer-scroll-short',
      'ciw-la-footer-subtotal-jump'
    );
  }

  function lockCardListFooterInset(footer) {
    if (!MQ_MOBILE_RX.matches) return;
    footer = footer || getFooter();
    if (!footer) return;
    var h = Math.ceil(footer.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--ciw-la-footer-h', h + 'px');
      cardListFooterInsetLocked = true;
    }
    var header = document.getElementById('la-prescription-modal-header');
    if (header) {
      var headerHeight = Math.ceil(header.getBoundingClientRect().height);
      if (headerHeight > 0) {
        document.documentElement.style.setProperty('--ciw-la-header-h', headerHeight + 'px');
      }
    }
  }

  function pauseLayoutIntervalForCardList() {
    if (!layoutInterval) return;
    window.clearInterval(layoutInterval);
    layoutInterval = null;
    layoutIntervalPausedForCardListScroll = true;
  }

  function resumeLayoutIntervalForCardList() {
    if (!layoutIntervalPausedForCardListScroll) return;
    layoutIntervalPausedForCardListScroll = false;
    if (!document.body.classList.contains('la-modal-open')) return;
    if (!isCardListMobileStepActive()) return;
    if (layoutInterval) return;
    layoutInterval = window.setInterval(function () {
      if (!document.body.classList.contains('la-modal-open')) {
        window.clearInterval(layoutInterval);
        layoutInterval = null;
        return;
      }
      if (cardListLayoutPaused) return;
      scheduleFooterLayout();
    }, 300);
  }

  function pauseFooterResizeObserverForCardList() {
    if (!footerResizeObserver || !cardListFooterObservedEl) return;
    footerResizeObserver.unobserve(cardListFooterObservedEl);
  }

  function resumeFooterResizeObserverForCardList() {
    if (!footerResizeObserver || !cardListFooterObservedEl) return;
    if (cardListLayoutPaused) return;
    footerResizeObserver.observe(cardListFooterObservedEl);
  }

  function pauseCardListLayoutDuringScroll() {
    if (!isCardListMobileStepActive()) return;
    cardListLayoutPaused = true;
    pauseLayoutIntervalForCardList();
    pauseFooterResizeObserverForCardList();
  }

  function resumeCardListLayoutAfterScroll() {
    if (!isCardListMobileStepActive()) return;
    cardListLayoutPaused = false;
    resumeLayoutIntervalForCardList();
    resumeFooterResizeObserverForCardList();
  }

  function onCardListScrollContainerScroll() {
    if (!isCardListMobileStepActive()) return;
    pauseCardListLayoutDuringScroll();
    if (cardListScrollResumeTimer) {
      window.clearTimeout(cardListScrollResumeTimer);
    }
    cardListScrollResumeTimer = window.setTimeout(function () {
      cardListScrollResumeTimer = null;
      resumeCardListLayoutAfterScroll();
    }, CARD_LIST_SCROLL_RESUME_MS);
  }

  function bindCardListScrollPause() {
    if (!isCardListMobileStepActive()) {
      unbindCardListScrollPause();
      return;
    }
    var scroller = getFooterScrollContainer();
    if (!scroller) return;
    if (cardListScrollBoundEl === scroller) return;
    unbindCardListScrollPause();
    scroller.addEventListener('scroll', onCardListScrollContainerScroll, { passive: true });
    cardListScrollBoundEl = scroller;
  }

  function unbindCardListScrollPause() {
    if (cardListScrollBoundEl) {
      cardListScrollBoundEl.removeEventListener('scroll', onCardListScrollContainerScroll);
      cardListScrollBoundEl = null;
    }
    if (cardListScrollResumeTimer) {
      window.clearTimeout(cardListScrollResumeTimer);
      cardListScrollResumeTimer = null;
    }
  }

  function resetCardListScrollPauseState() {
    cardListFooterInsetLocked = false;
    cardListLayoutPaused = false;
    layoutIntervalPausedForCardListScroll = false;
    unbindCardListScrollPause();
    resumeLayoutIntervalForCardList();
    resumeFooterResizeObserverForCardList();
  }

  function syncCardListStepClasses(active) {
    var isActive = typeof active === 'boolean' ? active : isCardListSubtotalOnlyStep();
    document.body.classList.toggle('ciw-la-card-list-step', isActive);
    var modal = getModalHost();
    if (modal) {
      modal.classList.toggle('ciw-la-card-list-footer-active', isActive);
    }
    if (!isActive) {
      resetCardListScrollPauseState();
    }
  }

  function hideCardListFooterAction(footer) {
    footer.classList.remove('ciw-la-subtotal-footer--show-action');
    var buttonWrap = footer.querySelector('.la-subtotal-footer-button');
    if (!buttonWrap) return;
    var laBtn = buttonWrap.querySelector('.la-prescription-form-btn');
    hideLaActionButton(buttonWrap, laBtn);
  }

  function fixCardListSubtotalFooter() {
    if (!MQ_MOBILE_RX.matches || !document.body.classList.contains('la-modal-open')) {
      syncCardListStepClasses(false);
      return false;
    }
    if (!isCardListSubtotalOnlyStep()) {
      syncCardListStepClasses(false);
      return false;
    }

    var modal = getModalHost();
    var footer = getFooter();
    var wrapper = getRxWrapper();
    if (!modal || !footer || !wrapper) return false;

    ensureMobileFooterPinned();

    wrapper.classList.remove('ciw-la-rx-step', 'ciw-la-flow-step', 'ciw-la-review-step');
    wrapper.classList.add('ciw-la-review-footer-active');

    var imageCol = wrapper.querySelector(':scope > .la-prescription-modal-image');
    if (imageCol) {
      imageCol.setAttribute('hidden', 'hidden');
      imageCol.setAttribute('aria-hidden', 'true');
      imageCol.classList.add('ciw-la-rx-step-image');
    }

    ensureSubtotalCard(footer);
    syncCardListStepClasses(true);
    hideCardListFooterAction(footer);

    footer.classList.remove('ciw-la-footer-subtotal-jump');

    if (!cardListFooterInsetLocked) {
      lockCardListFooterInset(footer);
    }
    bindCardListScrollPause();
    bindFooterScrollEnd();
    syncFooterScrollEnd();
    syncPinnedFooterModalClass();
    return true;
  }

  function shouldPinActionFooter() {
    if (isContactManualEntryStep() || isContactUploadStep()) return MQ_MOBILE_RX.matches;
    if (!MQ_MOBILE_RX.matches) return false;
    if (isContactLensFormStep()) return true;
    var footer = getFooter();
    if (!footer) return false;
    if (isCardListSubtotalOnlyStep()) return true;
    ensureSubtotalCard(footer);
    if (!footer.classList.contains('ciw-la-subtotal-footer--ready')) return false;
    return isPastUsageStep();
  }

  function syncFooterSubtotalVisibility(footer) {
    if (!footer) footer = getFooter();
    if (!footer || !footer.classList.contains('ciw-la-review-footer--pinned')) return;
    if (shouldAlwaysShowSubtotal(footer)) {
      applyFooterSubtotalVisible(footer);
      return;
    }
    bindFooterScrollEnd();
  }

  function fixReviewFooterPin() {
    if (!document.body.classList.contains('la-modal-open')) return;

    if (fixContactSubtotalOnlyFooter()) {
      return;
    }

    if (fixContactManualEntryFooter()) {
      syncFooterActionButton();
      return;
    }

    var footer = getFooter();
    var wrapper = getRxWrapper();
    var modal = getModalHost();
    if (!footer || !wrapper || !modal) return;

    ensureSubtotalCard(footer);

    var shouldPin = shouldPinActionFooter();

    if (!shouldPin) {
      unpinReviewFooter(wrapper);
      return;
    }

    if (footer.parentElement !== modal) {
      modal.appendChild(footer);
    }
    footer.classList.add('ciw-la-review-footer--pinned');
    footer.classList.toggle('ciw-la-mobile-footer-shell', MQ_MOBILE_RX.matches);
    wrapper.classList.add('ciw-la-review-footer-active');
    syncPinnedFooterModalClass();
    updateFooterInset();
    syncFooterSubtotalVisibility(footer);
  }

  function restorePrescriptionStepLayout(wrapper) {
    if (!wrapper) wrapper = getRxWrapper();
    if (!wrapper) return;

    wrapper.classList.remove('ciw-la-rx-step', 'ciw-la-review-footer-active');

    var imageCol = wrapper.querySelector(':scope > .la-prescription-modal-image');
    if (!imageCol) return;

    imageCol.removeAttribute('hidden');
    imageCol.removeAttribute('aria-hidden');
    imageCol.classList.remove('ciw-la-rx-step-image');
  }

  function restoreFlowFooterLayout(wrapper) {
    if (!wrapper) wrapper = getRxWrapper();
    if (!wrapper) return;

    unpinReviewFooter(wrapper);
    wrapper.classList.remove('ciw-la-flow-step', 'ciw-la-review-step');
    moveFooterToImageColumn(wrapper);
  }

  function fixPrescriptionStepLayout() {
    var wrapper = getRxWrapper();
    if (!wrapper) return;

    if (!shouldApplyRxLayoutFix()) {
      restorePrescriptionStepLayout(wrapper);
      return;
    }

    if (isCardListSubtotalOnlyStep()) {
      return;
    }

    var footer = getFooter();
    if (!footer) return;

    var imageCol = wrapper.querySelector(':scope > .la-prescription-modal-image');
    if (imageCol && imageCol.contains(footer) && !MQ_MOBILE_RX.matches) {
      moveFooterToWrapper(wrapper, footer);
    }

    wrapper.classList.add('ciw-la-rx-step', 'ciw-la-review-footer-active');
    if (MQ_MOBILE_RX.matches) {
      ensureMobileFooterPinned();
    }

    if (imageCol) {
      imageCol.setAttribute('hidden', 'hidden');
      imageCol.setAttribute('aria-hidden', 'true');
      imageCol.classList.add('ciw-la-rx-step-image');
    }

    updateFooterInset();
  }

  function fixFlowFooterLayout() {
    var wrapper = getRxWrapper();
    if (!wrapper) return;

    if (!shouldApplyFlowLayoutFix()) {
      restoreFlowFooterLayout(wrapper);
      return;
    }

    var footer = getFooter();
    if (!footer) return;

    // Mobile-only grid reflow; desktop keeps LensAdvisor's native horizontal layout.
    if (MQ_MOBILE_RX.matches) {
      wrapper.classList.add('ciw-la-flow-step');
      ensureMobileFooterPinned();
    } else {
      wrapper.classList.remove('ciw-la-flow-step');
      moveFooterToImageColumn(wrapper);
      syncDesktopActionButtonPlacement(footer);
    }
    updateFooterInset();
  }

  function fixFooterLayout() {
    if (!document.body.classList.contains('la-modal-open')) {
      restoreAllLayouts();
      return;
    }

    fixModalHeaderPlacement();
    syncReviewStepClass();

    if (shouldApplyRxLayoutFix()) {
      fixPrescriptionStepLayout();
      fixReviewFooterPin();
      return;
    }

    restorePrescriptionStepLayout();
    fixFlowFooterLayout();
    fixReviewFooterPin();
  }

  function scheduleFooterLayout() {
    if (layoutFrame) return;
    layoutFrame = window.requestAnimationFrame(function () {
      layoutFrame = null;
      if (cardListLayoutPaused && isCardListMobileStepActive()) {
        return;
      }
      fixModalHeaderPlacement();
      syncReviewStepClass();
      var layoutFooter = getFooter();
      if (layoutFooter) ensureSubtotalCard(layoutFooter);
      ensureMobileFooterPinned();

    if (fixContactSubtotalOnlyFooter()) {
      syncPinnedFooterModalClass();
      updateFooterInset();
      clearContactDesktopFooterButtonWidth(getFooter());
      if (window.LensAdvizor) renderSubtotalFooter(window.LensAdvizor);
      return;
    }

    if (fixContactManualEntryFooter()) {
      syncFooterActionButton();
      syncPinnedFooterModalClass();
      updateFooterInset();
      if (window.LensAdvizor) renderSubtotalFooter(window.LensAdvizor);
      scheduleContactDesktopFooterButtonWidth();
      return;
    }

    syncFooterActionButton();

      if (fixCardListSubtotalFooter()) {
        syncPinnedFooterModalClass();
        return;
      }

      fixReviewFooterPin();

      if (shouldApplyRxLayoutFix()) {
        fixPrescriptionStepLayout();
        fixReviewFooterPin();
        updateFooterInset();
        bindFooterScrollEnd();
        return;
      }

      restorePrescriptionStepLayout();
      fixFlowFooterLayout();
      fixReviewFooterPin();
      updateFooterInset();
      bindFooterScrollEnd();
      scheduleContactDesktopFooterButtonWidth();
    });
  }

  function updateFooterInset() {
    var footer = getFooter();
    if (footer) {
      var skipFooterHeight =
        isCardListMobileStepActive() &&
        (cardListFooterInsetLocked || cardListLayoutPaused);
      if (!skipFooterHeight) {
        var h = Math.ceil(footer.getBoundingClientRect().height);
        if (h > 0) {
          document.documentElement.style.setProperty('--ciw-la-footer-h', h + 'px');
        }
      }
    }

    var header = document.getElementById('la-prescription-modal-header');
    if (header) {
      var headerHeight = Math.ceil(header.getBoundingClientRect().height);
      if (headerHeight > 0) {
        document.documentElement.style.setProperty('--ciw-la-header-h', headerHeight + 'px');
      }
    }
  }

  function getFooterScrollContainer() {
    var wrapper = getRxWrapper();
    if (!wrapper || !wrapper.classList.contains('ciw-la-review-footer-active')) return null;
    return wrapper.querySelector('.la-prescription-modal-content-body');
  }

  function isScrollContainerScrollable(scroller) {
    if (!scroller) return false;
    return scroller.scrollHeight - scroller.clientHeight > SCROLL_END_THRESHOLD;
  }

  function isScrollContainerAtEnd(scroller) {
    if (!scroller || !isScrollContainerScrollable(scroller)) return false;
    return (
      scroller.scrollTop + scroller.clientHeight >=
      scroller.scrollHeight - SCROLL_END_THRESHOLD
    );
  }

  function shouldAlwaysShowSubtotal(footer) {
    if (!footer) footer = getFooter();
    if (!footer) return false;
    if (!footer.classList.contains('ciw-la-subtotal-footer--show-action')) return true;
    if (isContactLensFormStep()) return true;
    if (isReviewStep()) return true;
    if (isManualEntryStep()) return true;
    if (isUploadRxStep()) return true;
    if (isLensPackageContinueStep()) return true;
    if (isLensThicknessContinueStep()) return true;
    if (isLensColorContinueStep()) return true;
    if (isSunglassesLensSelectionStep()) return true;
    if (isProgressiveTypeOptionsStep()) return true;
    if (isProgressivePackageContinueStep() || isSunglassesPackageContinueStep()) return true;
    if (isRenderOptionsStep()) return true;
    return false;
  }

  function applyFooterSubtotalVisible(footer) {
    if (!footer) return;
    footer.classList.add('ciw-la-footer-at-scroll-end');
    footer.classList.remove('ciw-la-footer-scroll-short', 'ciw-la-footer-subtotal-jump');
    var wrapper = getRxWrapper();
    if (wrapper) wrapper.classList.remove('ciw-la-step-scroll-short');
    wasAtScrollEnd = true;
    window.requestAnimationFrame(updateFooterInset);
  }

  function clearFooterScrollEndState(footer) {
    if (!footer) footer = getFooter();
    if (!footer) return;
    footer.classList.remove('ciw-la-footer-at-scroll-end', 'ciw-la-footer-subtotal-jump');
  }

  function triggerSubtotalLineJump(footer) {
    if (!footer) return;
    footer.classList.remove('ciw-la-footer-subtotal-jump');
    void footer.offsetWidth;
    footer.classList.add('ciw-la-footer-subtotal-jump');
  }

  function syncFooterScrollEnd() {
    if (!MQ_MOBILE_RX.matches || !document.body.classList.contains('la-modal-open')) {
      unbindFooterScrollEnd();
      return;
    }

    var footer = getFooter();
    var scroller = getFooterScrollContainer();
    if (!footer || !footer.classList.contains('ciw-la-review-footer--pinned')) {
      unbindFooterScrollEnd();
      return;
    }

    if (shouldAlwaysShowSubtotal(footer)) {
      applyFooterSubtotalVisible(footer);
      return;
    }

    if (!scroller) {
      if (shouldAlwaysShowSubtotal(footer)) {
        applyFooterSubtotalVisible(footer);
      } else {
        clearFooterScrollEndState(footer);
        wasAtScrollEnd = false;
        var emptyWrapper = getRxWrapper();
        if (emptyWrapper) emptyWrapper.classList.remove('ciw-la-step-scroll-short');
      }
      return;
    }

    var forceScrollLayout = shouldKeepScrollableLayout();
    var atEnd = isScrollContainerAtEnd(scroller);
    var scrollable = isScrollContainerScrollable(scroller);
    var wrapper = getRxWrapper();

    if (forceScrollLayout && wrapper) {
      wrapper.classList.remove('ciw-la-step-scroll-short');
    }

    footer.classList.toggle('ciw-la-footer-scroll-short', !scrollable && !forceScrollLayout);
    footer.classList.toggle('ciw-la-footer-at-scroll-end', scrollable ? atEnd : true);

    if (!scrollable && !forceScrollLayout) {
      footer.classList.remove('ciw-la-footer-subtotal-jump');
      wasAtScrollEnd = true;
      updateFooterInset();
      if (wrapper) wrapper.classList.add('ciw-la-step-scroll-short');
      return;
    }

    if (wrapper) wrapper.classList.remove('ciw-la-step-scroll-short');

    if (atEnd && !wasAtScrollEnd && !isManualEntryStep() && !isUploadRxStep()) {
      triggerSubtotalLineJump(footer);
      window.requestAnimationFrame(updateFooterInset);
    } else if (!atEnd) {
      footer.classList.remove('ciw-la-footer-subtotal-jump');
      window.requestAnimationFrame(updateFooterInset);
    }

    wasAtScrollEnd = atEnd;
  }

  function onFooterScrollContainerScroll() {
    if (scrollEndFrame) return;
    scrollEndFrame = window.requestAnimationFrame(function () {
      scrollEndFrame = null;
      syncFooterScrollEnd();
    });
  }

  function bindFooterScrollEnd() {
    if (!MQ_MOBILE_RX.matches) {
      unbindFooterScrollEnd();
      return;
    }

    var footer = getFooter();
    if (footer && footer.classList.contains('ciw-la-review-footer--pinned') && shouldAlwaysShowSubtotal(footer)) {
      applyFooterSubtotalVisible(footer);
      return;
    }

    var scroller = getFooterScrollContainer();
    if (!scroller) {
      return;
    }

    if (scrollEndBoundEl !== scroller) {
      if (scrollEndBoundEl) {
        scrollEndBoundEl.removeEventListener('scroll', onFooterScrollContainerScroll);
      }
      scroller.addEventListener('scroll', onFooterScrollContainerScroll, { passive: true });
      scrollEndBoundEl = scroller;
      wasAtScrollEnd = isScrollContainerAtEnd(scroller);
    }

    syncFooterScrollEnd();
  }

  function unbindFooterScrollEnd() {
    if (scrollEndBoundEl) {
      scrollEndBoundEl.removeEventListener('scroll', onFooterScrollContainerScroll);
      scrollEndBoundEl = null;
    }
    if (scrollEndFrame) {
      window.cancelAnimationFrame(scrollEndFrame);
      scrollEndFrame = null;
    }
    wasAtScrollEnd = false;
    clearFooterScrollEndState();
    var wrapper = getRxWrapper();
    if (wrapper) wrapper.classList.remove('ciw-la-step-scroll-short');
  }

  function watchFooterHeight(footer) {
    if (!footer || footerResizeObserver) return;
    if (typeof ResizeObserver === 'undefined') return;
    cardListFooterObservedEl = footer;
    footerResizeObserver = new ResizeObserver(function () {
      if (isCardListMobileStepActive() && (cardListLayoutPaused || cardListFooterInsetLocked)) {
        return;
      }
      updateFooterInset();
    });
    footerResizeObserver.observe(footer);
  }

  function hideLaActionButton(buttonWrap, laBtn) {
    if (!buttonWrap) return;
    buttonWrap.setAttribute('hidden', 'hidden');
    if (typeof buttonWrap.laHide === 'function') {
      buttonWrap.laHide();
    } else {
      buttonWrap.style.display = 'none';
    }
    if (laBtn && typeof laBtn.laHide === 'function') {
      laBtn.laHide();
    } else if (laBtn) {
      laBtn.style.display = 'none';
    }
  }

  function revealLaActionButton(buttonWrap, laBtn) {
    if (!buttonWrap || !laBtn) return;
    buttonWrap.removeAttribute('hidden');
    if (typeof buttonWrap.laShow === 'function') {
      buttonWrap.laShow();
    } else {
      buttonWrap.style.removeProperty('display');
    }
    buttonWrap.style.removeProperty('height');
    buttonWrap.style.removeProperty('max-height');
    buttonWrap.style.removeProperty('min-height');
    buttonWrap.style.removeProperty('overflow');
    buttonWrap.style.setProperty('pointer-events', 'auto', 'important');
    if (typeof laBtn.laShow === 'function') {
      laBtn.laShow();
    } else {
      laBtn.style.removeProperty('display');
    }
    laBtn.style.removeProperty('height');
    laBtn.style.removeProperty('max-height');
    laBtn.style.removeProperty('min-height');
    laBtn.style.removeProperty('overflow');
    laBtn.style.setProperty('pointer-events', 'auto', 'important');
  }

  function revealFooterShell(footer) {
    if (!footer) return;
    footer.removeAttribute('hidden');
    if (typeof footer.laShow === 'function') {
      footer.laShow();
    }
    footer.style.removeProperty('display');
    footer.style.setProperty('display', 'block', 'important');
    footer.style.setProperty('visibility', 'visible', 'important');
    footer.style.setProperty('pointer-events', 'auto', 'important');
    footer.style.setProperty('opacity', '1', 'important');
  }

  function hideContactFooterAction(footer) {
    if (!footer) footer = getFooter();
    if (!footer) return;
    footer.classList.remove('ciw-la-subtotal-footer--show-action');
    var buttonWrap = footer.querySelector('.la-subtotal-footer-button');
    if (!buttonWrap) return;
    var laBtn = buttonWrap.querySelector('.la-prescription-form-btn');
    if (!laBtn && buttonWrap.matches && buttonWrap.matches('.la-prescription-form-btn')) {
      laBtn = buttonWrap;
    }
    hideLaActionButton(buttonWrap, laBtn);
  }

  function fixContactSubtotalOnlyFooter() {
    if (!isContactSubtotalOnlyStep()) return false;

    var modal = getModalHost();
    var wrapper = getRxWrapper();
    var footer = getFooter();
    if (!footer) return false;

    footer.classList.add('ciw-la-subtotal-only-footer');
    footer.classList.remove('ciw-la-subtotal-footer--show-action');
    ensureSubtotalCard(footer);
    applyFooterSubtotalVisible(footer);
    revealFooterShell(footer);
    hideContactFooterAction(footer);

    if (MQ_MOBILE_RX.matches) {
      if (modal && footer.parentElement !== modal) {
        modal.appendChild(footer);
      }
      footer.classList.add(
        'ciw-la-review-footer--pinned',
        'ciw-la-footer-at-scroll-end',
        'ciw-la-mobile-footer-shell'
      );
      if (wrapper) {
        wrapper.classList.add('ciw-la-review-footer-active');
        syncCardListStepClasses(true);
      }
    } else {
      var imageCol = wrapper && wrapper.querySelector(':scope > .la-prescription-modal-image');
      if (imageCol) {
        if (footer.parentElement !== imageCol) {
          imageCol.appendChild(footer);
        }
        imageCol.removeAttribute('hidden');
        imageCol.removeAttribute('aria-hidden');
        imageCol.classList.remove('ciw-la-rx-step-image');
      }
      footer.classList.remove(
        'ciw-la-review-footer--pinned',
        'ciw-la-mobile-footer-shell',
        'ciw-la-footer-at-scroll-end'
      );
      if (wrapper) {
        wrapper.classList.remove('ciw-la-flow-step', 'ciw-la-review-footer-active');
      }
      syncCardListStepClasses(false);
    }

    syncPinnedFooterModalClass();
    updateFooterInset();
    bindFooterScrollEnd();
    if (window.LensAdvizor) renderSubtotalFooter(window.LensAdvizor);
    return true;
  }

  function fixContactManualEntryFooter() {
    if (!isContactManualEntryStep() && !isContactUploadStep()) return false;
    if (!document.body.classList.contains('la-modal-open')) return false;

    var modal = getModalHost();
    var wrapper = getRxWrapper();
    var footer = getFooter();
    if (!footer) return false;

    footer.classList.remove('ciw-la-subtotal-only-footer');
    ensureSubtotalCard(footer);
    applyFooterSubtotalVisible(footer);
    revealFooterShell(footer);

    if (MQ_MOBILE_RX.matches) {
      if (modal && footer.parentElement !== modal) {
        modal.appendChild(footer);
      }
      footer.classList.add(
        'ciw-la-review-footer--pinned',
        'ciw-la-footer-at-scroll-end',
        'ciw-la-mobile-footer-shell'
      );
      if (wrapper) {
        wrapper.classList.add('ciw-la-flow-step', 'ciw-la-review-footer-active');
        syncCardListStepClasses(false);
      }
    } else {
      var imageCol = wrapper && wrapper.querySelector(':scope > .la-prescription-modal-image');
      if (imageCol) {
        if (footer.parentElement !== imageCol) {
          imageCol.appendChild(footer);
        }
        imageCol.removeAttribute('hidden');
        imageCol.removeAttribute('aria-hidden');
        imageCol.classList.remove('ciw-la-rx-step-image');
      }
      footer.classList.remove(
        'ciw-la-review-footer--pinned',
        'ciw-la-mobile-footer-shell',
        'ciw-la-footer-at-scroll-end'
      );
      if (wrapper) {
        wrapper.classList.remove('ciw-la-flow-step', 'ciw-la-review-footer-active');
      }
      syncCardListStepClasses(false);
    }

    syncPinnedFooterModalClass();
    updateFooterInset();
    bindFooterScrollEnd();
    return true;
  }

  function syncFooterActionButton(footer) {
    if (!footer) footer = getFooter();
    if (!footer || !footer.classList.contains('ciw-la-subtotal-footer--ready')) return;

    var la = getLensAdvizor();
    var buttonWrap =
      (la && la.formBtn) || footer.querySelector('.la-subtotal-footer-button');
    if (!buttonWrap) return;

    var laBtn = buttonWrap.querySelector('.la-prescription-form-btn');
    if (!laBtn && buttonWrap.matches && buttonWrap.matches('.la-prescription-form-btn')) {
      laBtn = buttonWrap;
    }
    if (!laBtn && buttonWrap.firstElementChild && buttonWrap.firstElementChild !== buttonWrap) {
      laBtn = buttonWrap.firstElementChild;
    }
    if (!laBtn) return;

    if (!shouldShowFooterActionButton()) {
      footer.classList.remove('ciw-la-subtotal-footer--show-action');
      hideLaActionButton(buttonWrap, laBtn);
      syncDesktopActionButtonPlacement(footer);
      return;
    }

    var isEnabled =
      !laBtn.disabled &&
      laBtn.getAttribute('disabled') === null;

    if (
      !isEnabled &&
      !isManualEntryStep() &&
      !isContactManualEntryStep() &&
      !isContactUploadStep() &&
      !isUploadRxStep() &&
      !isLensPackageContinueStep() &&
      !isLensThicknessContinueStep() &&
      !isLensColorContinueStep() &&
      !isSunglassesLensSelectionStep() &&
      !isProgressivePackageContinueStep() &&
      !isProgressiveTypeOptionsStep() &&
      !isSunglassesPackageContinueStep() &&
      !isTransitionsDrawerStep() &&
      !isRenderOptionsStep() &&
      !isAddOnsContinueStep()
    ) {
      footer.classList.remove('ciw-la-subtotal-footer--show-action');
      hideLaActionButton(buttonWrap, laBtn);
      syncDesktopActionButtonPlacement(footer);
      return;
    }

    footer.classList.add('ciw-la-subtotal-footer--show-action');
    revealLaActionButton(buttonWrap, laBtn);
    syncDesktopActionButtonPlacement(footer);
    window.requestAnimationFrame(function () {
      updateFooterInset();
      fixReviewFooterPin();
    });

    if (isReviewStep()) {
      var label = 'Add to cart';
      var textNode = laBtn.firstElementChild || laBtn;
      if (textNode && textNode.textContent !== label) {
        textNode.textContent = label;
      }
      laBtn.disabled = false;
      laBtn.removeAttribute('disabled');
      laBtn.setAttribute('aria-label', label);
    } else if (
      isLensPackageContinueStep() ||
      isLensThicknessContinueStep() ||
      isLensColorContinueStep() ||
      isSunglassesLensSelectionStep() ||
      isProgressivePackageContinueStep() ||
      isSunglassesPackageContinueStep() ||
      isTransitionsDrawerStep()
    ) {
      var continueLabel = 'Continue';
      var continueTextNode = laBtn.firstElementChild || laBtn;
      if (continueTextNode && continueTextNode.textContent !== continueLabel) {
        continueTextNode.textContent = continueLabel;
      }
      var continueReady = true;
      if (isLensColorContinueStep()) {
        var colorApi = window.ciwLaLensColorContinue;
        continueReady =
          colorApi &&
          typeof colorApi.isContinueEnabled === 'function' &&
          colorApi.isContinueEnabled();
      } else if (isSunglassesLensSelectionStep()) {
        var sunglassesApi = window.ciwLaSunglassesLensSelection;
        continueReady =
          sunglassesApi &&
          typeof sunglassesApi.isFooterContinueReady === 'function' &&
          sunglassesApi.isFooterContinueReady();
      } else if (isProgressivePackageContinueStep() || isSunglassesPackageContinueStep()) {
        var progApi = window.ciwLaProgressivePackageContinue;
        continueReady = !!(progApi && typeof progApi.hasSelection === 'function' && progApi.hasSelection());
      } else if (isTransitionsDrawerStep()) {
        var transitionsApi = window.ciwLaTransitionsDrawer;
        continueReady =
          transitionsApi &&
          typeof transitionsApi.isContinueEnabled === 'function' &&
          transitionsApi.isContinueEnabled();
      }
      laBtn.disabled = !continueReady;
      if (continueReady) {
        laBtn.removeAttribute('disabled');
      } else {
        laBtn.setAttribute('disabled', 'disabled');
      }
      laBtn.setAttribute('aria-label', continueLabel);
      if (isTransitionsDrawerStep() && MQ_MOBILE_RX.matches) {
        footer.classList.add('ciw-la-footer-at-scroll-end');
      }
    } else if (isContactManualEntryStep() || isContactUploadStep()) {
      var contactSaveLabel = 'Save and Continue';
      var contactSaveTextNode = laBtn.firstElementChild || laBtn;
      if (contactSaveTextNode && contactSaveTextNode.textContent !== contactSaveLabel) {
        contactSaveTextNode.textContent = contactSaveLabel;
      }
      laBtn.setAttribute('aria-label', contactSaveLabel);
      if (isContactUploadStep()) {
        var uploadForm = document.querySelector('#la-prescription-form.ciw-la-contact-upload-form--mobile');
        var uploadReady = !!(uploadForm && uploadForm.checkValidity());
        laBtn.disabled = !uploadReady;
        if (uploadReady) {
          laBtn.removeAttribute('disabled');
        } else {
          laBtn.setAttribute('disabled', 'disabled');
        }
      }
    } else if (isManualEntryStep() || isUploadRxStep() || isRenderOptionsStep()) {
      var saveLabel = 'Continue';
      var saveTextNode = laBtn.firstElementChild || laBtn;
      if (saveTextNode && saveTextNode.textContent !== saveLabel) {
        saveTextNode.textContent = saveLabel;
      }
      laBtn.disabled = false;
      laBtn.removeAttribute('disabled');
      laBtn.setAttribute('aria-label', saveLabel);
      if (saveTextNode && saveTextNode !== laBtn) {
        saveTextNode.removeAttribute('disabled');
      }
    } else if (isAddOnsContinueStep()) {
      var addonsSaveLabel = 'Continue';
      var addonsSaveTextNode = laBtn.firstElementChild || laBtn;
      if (addonsSaveTextNode && addonsSaveTextNode.textContent !== addonsSaveLabel) {
        addonsSaveTextNode.textContent = addonsSaveLabel;
      }
      laBtn.disabled = false;
      laBtn.removeAttribute('disabled');
      laBtn.setAttribute('aria-label', addonsSaveLabel);
      if (addonsSaveTextNode && addonsSaveTextNode !== laBtn) {
        addonsSaveTextNode.removeAttribute('disabled');
      }
    }
  }

  function ensureSubtotalCard(footer) {
    if (!footer) return null;
    var card = footer.querySelector('.ciw-la-subtotal-card');
    if (card) return card;

    footer.classList.add('ciw-la-subtotal-footer--ready');

    var rows = footer.querySelectorAll('.la-footer-row:not(.la-subtotal), .la-footer-dynamic-prices, .la-seperator');
    rows.forEach(function (row) {
      row.setAttribute('hidden', 'hidden');
    });

    var subtotalRow = footer.querySelector('.la-footer-row.la-subtotal');
    if (subtotalRow) subtotalRow.setAttribute('hidden', 'hidden');

    card = document.createElement('div');
    card.className = 'ciw-la-subtotal-card';
    card.innerHTML =
      '<div class="ciw-la-subtotal-card__line">' +
      '<span class="ciw-la-subtotal-card__label">Subtotal:</span> ' +
      '<span class="ciw-la-subtotal-card__prices" data-ciw-la-subtotal-prices></span>' +
      '</div>' +
      '<div class="ciw-la-subtotal-card__pay-row">' +
      '<span class="ciw-la-subtotal-card__pay-muted">Pay over time with </span>' +
      '<strong class="ciw-la-subtotal-card__pay-brand">Shop Pay</strong>' +
      '<span class="ciw-la-subtotal-card__pay-muted"> or </span>' +
      '<strong class="ciw-la-subtotal-card__pay-brand">PayPal</strong>' +
      '<button type="button" class="ciw-la-subtotal-card__help" aria-label="Shop Pay learn more">' +
      '<span aria-hidden="true">?</span>' +
      '</button>' +
      '</div>';

    var buttonWrap = footer.querySelector('.la-subtotal-footer-button');
    if (buttonWrap) {
      footer.insertBefore(card, buttonWrap);
    } else {
      footer.appendChild(card);
    }

    bindShopPayHelp(card);
    watchFooterHeight(footer);
    return card;
  }

  function openShopPayLearnMore() {
    var sourceForm = INSTALLMENT_FORM_ID ? document.getElementById(INSTALLMENT_FORM_ID) : null;
    var terms = sourceForm && sourceForm.querySelector('shopify-payment-terms');
    if (!terms) return false;

    var root = terms.shadowRoot;
    if (!root) return false;

    var learnMore =
      root.querySelector('button[aria-label*="Learn"]') ||
      root.querySelector('button[aria-label*="learn"]') ||
      root.querySelector('a[href*="shop"]') ||
      Array.from(root.querySelectorAll('button, a')).find(function (el) {
        return /learn more/i.test(String(el.textContent || ''));
      });

    if (!learnMore) return false;
    learnMore.click();
    return true;
  }

  function bindShopPayHelp(card) {
    var helpBtn = card.querySelector('.ciw-la-subtotal-card__help');
    if (!helpBtn || helpBtn.dataset.ciwBound === '1') return;
    helpBtn.dataset.ciwBound = '1';

    helpBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openShopPayLearnMore();
    });
  }

  function getPromoAdjustedAmounts(subtotalAmount, lensAdvizor) {
    var listAmount = subtotalAmount;
    var saleAmount = subtotalAmount;
    var framePrice = lensAdvizor && lensAdvizor.prices ? parseFloat(lensAdvizor.prices.frame) : NaN;
    if (isNaN(framePrice)) framePrice = 0;
    var nonFrameAmount = Math.max(0, subtotalAmount - framePrice);

    if (FIRST30 && config.first30FrameList > 0 && config.first30FrameSale >= 0) {
      listAmount = config.first30FrameList + nonFrameAmount;
      saleAmount = config.first30FrameSale + nonFrameAmount;
      return { listAmount: listAmount, saleAmount: saleAmount, promoCode: 'FIRST30' };
    }

    if (RELENS20) {
      listAmount = subtotalAmount;
      saleAmount = Math.max(0, subtotalAmount - RELENS20_AMOUNT);
      return { listAmount: listAmount, saleAmount: saleAmount, promoCode: 'RELENS20' };
    }

    return { listAmount: listAmount, saleAmount: saleAmount, promoCode: '' };
  }

  function renderPrices(card, subtotalAmount, lensAdvizor) {
    var pricesEl = card.querySelector('[data-ciw-la-subtotal-prices]');
    if (!pricesEl) return;

    var promo = getPromoAdjustedAmounts(subtotalAmount, lensAdvizor);
    var saleText = formatMoneyFromAmount(promo.saleAmount);

    if (!promo.promoCode) {
      pricesEl.innerHTML = '<span class="ciw-la-subtotal-card__sale">' + saleText + '</span>';
      return;
    }

    pricesEl.innerHTML =
      '<s class="ciw-la-subtotal-card__list">' +
      formatMoneyFromAmount(promo.listAmount) +
      '</s> ' +
      '<span class="ciw-la-subtotal-card__sale">' +
      saleText +
      '</span> ' +
      '<span class="ciw-la-subtotal-card__divider" aria-hidden="true">|</span> ' +
      '<span class="ciw-la-subtotal-card__code">' +
      TAG_ICON +
      '<span>' +
      promo.promoCode +
      '</span></span>';
  }

  function renderSubtotalFooter(lensAdvizor) {
    if (!isCiwLaHost()) return;
    var footer = getFooter();
    if (!footer) return;

    var card = ensureSubtotalCard(footer);
    syncFooterActionButton(footer);

    if (!card || !lensAdvizor || !lensAdvizor.prices) return;

    var subtotal = parseFloat(lensAdvizor.prices.subtotal);
    if (isNaN(subtotal)) subtotal = 0;
    renderPrices(card, subtotal, lensAdvizor);
    scheduleContactDesktopFooterButtonWidth();
  }

  function patchLensAdvizorSubtotalFooter() {
    if (!window.LensAdvizor || typeof LensAdvizor.updateFooterPrices !== 'function') return false;
    if (LensAdvizor.__ciwSubtotalFooterPatched) return true;

    LensAdvizor.__ciwSubtotalFooterPatched = true;
    var originalPrices = LensAdvizor.updateFooterPrices.bind(LensAdvizor);
    LensAdvizor.updateFooterPrices = function () {
      var result = originalPrices.apply(this, arguments);
      renderSubtotalFooter(this);
      scheduleFooterLayout();
      return result;
    };

    if (typeof LensAdvizor.updateFormBtnState === 'function') {
      var originalBtnState = LensAdvizor.updateFormBtnState.bind(LensAdvizor);
      LensAdvizor.updateFormBtnState = function () {
        var result = originalBtnState.apply(this, arguments);
        syncFooterActionButton();
        fixReviewFooterPin();
        updateFooterInset();
        return result;
      };
    }

    return true;
  }

  function scheduleRender() {
    if (!window.LensAdvizor) return;
    renderSubtotalFooter(window.LensAdvizor);
    scheduleFooterLayout();
  }

  function startFooterLayoutWatch() {
    scheduleFooterLayout();
    if (window.LensAdvizor) {
      renderSubtotalFooter(window.LensAdvizor);
    }
    watchHeaderPlacement(getRxWrapper());
    if (layoutInterval) return;
    layoutInterval = window.setInterval(function () {
      if (!document.body.classList.contains('la-modal-open')) {
        window.clearInterval(layoutInterval);
        layoutInterval = null;
        return;
      }
      if (cardListLayoutPaused) return;
      scheduleFooterLayout();
    }, 300);
  }

  function stopFooterLayoutWatch() {
    stopHeaderPlacementWatch();
    unbindFooterScrollEnd();
    resetCardListScrollPauseState();
    if (layoutInterval) {
      window.clearInterval(layoutInterval);
      layoutInterval = null;
    }
    if (layoutFrame) {
      window.cancelAnimationFrame(layoutFrame);
      layoutFrame = null;
    }
  }

  function restoreAllLayouts() {
    unbindFooterScrollEnd();
    syncCardListStepClasses(false);
    var wrapper = getRxWrapper();
    var footer = getFooter();
    if (footer) {
      footer.classList.remove('ciw-la-review-footer--pinned', 'ciw-la-mobile-footer-shell');
    }
    if (wrapper) {
      wrapper.classList.remove('ciw-la-review-footer-active');
    }
    restorePrescriptionStepLayout(wrapper);
    restoreFlowFooterLayout(wrapper);
  }

  function bind() {
    var legacyStyle = document.getElementById('ciw-la-contact-desktop-footer-btn-styles');
    if (legacyStyle) legacyStyle.remove();

    if (typeof MQ_MOBILE_RX.addEventListener === 'function') {
      MQ_MOBILE_RX.addEventListener('change', function () {
        if (!document.body.classList.contains('la-modal-open')) return;
        scheduleFooterLayout();
      });
    } else if (typeof MQ_MOBILE_RX.addListener === 'function') {
      MQ_MOBILE_RX.addListener(function () {
        if (!document.body.classList.contains('la-modal-open')) return;
        scheduleFooterLayout();
      });
    }

    document.addEventListener('LensAdvizor:component:DidMount', scheduleRender);
    document.addEventListener('LensAdvizor:selectLensModal:open', startFooterLayoutWatch);
    document.addEventListener('ciw-la-lens-package:continue-sync', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
    });

    document.addEventListener('ciw-la-lens-thickness:continue-sync', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
    });

    document.addEventListener('ciw-la-lens-color:continue-sync', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
    });

    document.addEventListener('ciw-la-progressive-type:selection-changed', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
    });

    document.addEventListener('ciw-la-sunglasses-lens-selection:changed', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
    });

    document.addEventListener('ciw-la-sunglasses-lens-selection:confirmed', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
    });

    document.addEventListener('ciw-la-transitions-drawer:changed', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
      if (window.LensAdvizor) renderSubtotalFooter(window.LensAdvizor);
    });

    document.addEventListener('click', function (event) {
      if (!isSunglassesLensSelectionStep()) return;

      var sunglassesApi = window.ciwLaSunglassesLensSelection;
      if (!sunglassesApi || typeof sunglassesApi.confirm !== 'function') return;

      var btn = event.target.closest('.la-prescription-form-btn');
      if (!btn || !isLaModalActionButton(btn)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (
        typeof sunglassesApi.alertIfMissingColor === 'function' &&
        !sunglassesApi.alertIfMissingColor()
      ) {
        return;
      }
      if (
        typeof sunglassesApi.isContinueEnabled === 'function' &&
        !sunglassesApi.isContinueEnabled()
      ) {
        return;
      }

      sunglassesApi.confirm();
    }, true);

    document.addEventListener('click', function (event) {
      if (!isProgressivePackageContinueStep() && !isSunglassesPackageContinueStep()) return;

      var progApi = window.ciwLaProgressivePackageContinue;
      if (!progApi || typeof progApi.confirm !== 'function') return;
      if (typeof progApi.hasSelection === 'function' && !progApi.hasSelection()) return;

      var btn = event.target.closest('.la-prescription-form-btn');
      if (
        !btn ||
        !(
          btn.closest('.la-prescription-modal-footer') ||
          btn.closest('.ciw-la-subtotal-footer') ||
          btn.closest('.la-subtotal-footer-button')
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      progApi.confirm();
    }, true);

    document.addEventListener('click', function (event) {
      if (!isTransitionsDrawerStep()) return;

      var transitionsApi = window.ciwLaTransitionsDrawer;
      if (!transitionsApi || typeof transitionsApi.confirm !== 'function') return;

      var btn = event.target.closest('.la-prescription-form-btn');
      if (!btn || !isLaModalActionButton(btn)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (
        typeof transitionsApi.alertIfMissingColor === 'function' &&
        !transitionsApi.alertIfMissingColor()
      ) {
        return;
      }
      if (
        typeof transitionsApi.isContinueEnabled === 'function' &&
        !transitionsApi.isContinueEnabled()
      ) {
        return;
      }

      transitionsApi.confirm();
    }, true);

    document.addEventListener('click', function (event) {
      if (!isLensColorContinueStep()) return;

      var api = window.ciwLaLensColorContinue;
      if (!api || typeof api.confirm !== 'function') return;
      if (typeof api.isContinueEnabled === 'function' && !api.isContinueEnabled()) return;

      var btn = event.target.closest('.la-prescription-form-btn');
      if (!btn || !isLaModalActionButton(btn)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      api.confirm();
    }, true);

    document.addEventListener('ciw-la-addons:continue-sync', function () {
      syncFooterActionButton();
      fixReviewFooterPin();
      updateFooterInset();
    });

    document.addEventListener('ciw-la-review-step:scroll-sync', function () {
      bindFooterScrollEnd();
      syncFooterScrollEnd();
      updateFooterInset();
    });

    document.addEventListener('LensAdvizor:selectLensModal:close', function () {
      stopFooterLayoutWatch();
      restoreAllLayouts();
    });

    document.addEventListener(
      'animationend',
      function (event) {
        if (!event || event.animationName !== 'ciw-la-subtotal-line-jump') return;
        var footer = getFooter();
        if (footer) footer.classList.remove('ciw-la-footer-subtotal-jump');
      },
      true
    );

    [
      'LensAdvizor:prescriptionTypes:rendered',
      'LensAdvizor:lens:rendered',
      'LensAdvizor:lensOptions:rendered',
      'LensAdvizor:addOns:rendered',
      'LensAdvizor:review:rendered',
      'LensAdvizor:render:submissionMethods',
      'LensAdvizor:render:manualEntryForm',
      'LensAdvizor:render:contactLensForm',
      'LensAdvizor:render:uploadForm',
      'LensAdvizor:render:readingForm'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        window.setTimeout(scheduleRender, 0);
        window.setTimeout(scheduleRender, 150);
      });
    });

    document.addEventListener('click', function (event) {
      if (
        event.target.closest(
          'lensadvizor-btn, #la-select-lenses-btn, .la-select-lenses-btn, [class*="la-select-lenses"]'
        )
      ) {
        window.setTimeout(scheduleRender, 300);
        window.setTimeout(scheduleRender, 800);
      }
    });

    document.addEventListener('ciw-la-manual-rx:enhanced', scheduleFooterLayout);
    document.addEventListener('ciw-la-contact-rx:enhanced', scheduleFooterLayout);
    document.addEventListener('ciw-la-contact-rx:footer-sync', function () {
      scheduleRender();
      scheduleFooterLayout();
      scheduleContactDesktopFooterButtonWidth();
    });
    document.addEventListener('ciw-la-upload-rx:enhanced', scheduleFooterLayout);
    document.addEventListener('ciw-la-contact-upload:enhanced', scheduleFooterLayout);

    document.addEventListener('ciw-la-prism:changed', scheduleRender);

    document.addEventListener('change', function (event) {
      if (event.target.closest('#la-prescription-form')) {
        window.setTimeout(scheduleFooterLayout, 0);
      }
    });

    var wait = window.setInterval(function () {
      if (patchLensAdvizorSubtotalFooter()) {
        window.clearInterval(wait);
        scheduleRender();
      }
    }, 250);
    window.setTimeout(function () {
      window.clearInterval(wait);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
